import { DxDiagnosisResultStep } from '@src/api/company/dxDiagnosis/dxDiagnosisResultApiClient.ts';
import { DxDiagnosisStepCodeEnum } from '@src/enum/dxDiagnosisStepCodeEnum.ts';
import TabContainer from '@src/ui/elements/tab/TabContainer';
import { TabItem } from '@src/ui/elements/tab/types';

import {
  ContentsBranding,
  ContentsContinuation,
  ContentsDevelopment,
  ContentsDxMind,
  ContentsDxPlanning,
  ContentsInnovation,
} from './AnswerAndScoreTables';

const AnswerAndScoreTab = ({ data }: { data: DxDiagnosisResultStep[] }) => {
  const tabs: TabItem[] = Object.values(DxDiagnosisStepCodeEnum).map((code) => {
    const stepData = data.find((step) => step.code === code);
    return {
      id: code,
      label: stepData?.name,
      content: stepData ? (
        (() => {
          switch (code) {
            case DxDiagnosisStepCodeEnum.DX_MIND:
              return <ContentsDxMind stepData={stepData} />;
            case DxDiagnosisStepCodeEnum.BRANDING:
              return <ContentsBranding stepData={stepData} />;
            case DxDiagnosisStepCodeEnum.DX_STRATEGY:
              return <ContentsDxPlanning stepData={stepData} />;
            case DxDiagnosisStepCodeEnum.BUSINESS_TRANSFORMATION:
              return <ContentsInnovation stepData={stepData} />;
            case DxDiagnosisStepCodeEnum.NEW_VENTURES:
              return <ContentsDevelopment stepData={stepData} />;
            case DxDiagnosisStepCodeEnum.BUSINESS_CONTINUITY:
              return <ContentsContinuation stepData={stepData} />;
            default:
              return null;
          }
        })()
      ) : (
        <div></div>
      ),
    };
  });

  return <TabContainer tabs={tabs} />;
};

export default AnswerAndScoreTab;
